import { Injectable, signal } from '@angular/core';
import { Product } from '../types/product';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UriApi } from '../helpers/UriApi';
import { v4 as uuidv4 } from 'uuid';
import { retry } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  // FIX: Added placeholder images for products.
  body = {
    request: {
      jsonParams: {},
      functionCode: 109,
      data: "",
      dataList: "",
      menuCd: '',
    }
  };
  constructor(private http: HttpClient, private auth: AuthenticationService
  ) { }


  KEY_NAME = 'SERVICE_POS_IDEMPOTENCY';

  getOrCreateIdempotencyKey(): string {
    let key = localStorage.getItem(this.KEY_NAME);

    if (!key) {
      key = uuidv4();
      localStorage.setItem(this.KEY_NAME, key);
    }

    return key;
  }
  resetIdempotencyKey() {
    localStorage.removeItem(this.KEY_NAME);
  }
  getServices(jsonParams = {}) {
    return new Promise(async (resove, reject) => {
      const header = new Headers();
      let token = this.auth.getToken();
      let data;
      this.body.request.jsonParams = jsonParams;
      header.append('Content-Type', 'application/json');
      header.append('Accept', 'application/json');
      header.append('x-api-key', this.auth.getApiKey());
      header.append('strcd', this.auth.getStrCd() || '')
      if (token !== '') header.append('Authorization', `Bearer ${token}`);

      try {
        const response = await fetch(UriApi.api_ServicePos_Get, {
          method: 'POST',
          headers: header,
          body: JSON.stringify(this.body),
          credentials: 'include'
        });

        if (!response.ok) {
          reject(`Error: ${response.status} ${response.statusText}`);
        }
        data = await response.json();
        resove(data)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  addSale(param: any = {}) {
    this.body.request.jsonParams = param;
    const headers = new HttpHeaders({
      'Idempotency-Key': this.getOrCreateIdempotencyKey()
    });

    return this.http.post(
      UriApi.api_ServicePos_AddSale,
      this.body,
      { headers }
    ).pipe(retry(3));
  }

  cancelSale(param: any = {}) {
    this.body.request.jsonParams = param;
    return this.http.post(UriApi.api_ServicePos_CancelSale, this.body)
  }
}
